import { createApiAction } from '@app/packages/api/utils'
import type { V3PostBonusWithdrawalRequestsRequest } from '@app/packages/api/v3/types/params'
import type { V3GetBonusWithdrawalRequestsResponse, V3PostBonusWithdrawalRequestsResponse } from '@app/packages/api/v3/types/responses'

export const getBonusWithdrawalRequests = () =>
  createApiAction('getBonusWithdrawalRequests', dispatch =>
    dispatch<V3GetBonusWithdrawalRequestsResponse>({
      endpoint: '/api/v3/bonus_withdrawal_requests',
      method: 'GET',
    })
  )

export const postBonusWithdrawalRequests = (body: V3PostBonusWithdrawalRequestsRequest) =>
  createApiAction('postBonusWithdrawalRequests', dispatch =>
    dispatch<V3PostBonusWithdrawalRequestsResponse>({
      endpoint: '/api/v3/bonus_withdrawal_requests',
      method: 'POST',
      body: JSON.stringify(body),
    })
  )
